<template>
  <div class="titleBlue">{{ title }}</div>
</template>
<script>
export default {
  props: ["title"]
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";

.titleBlue {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    45px/60px var(--unnamed-font-family-segoe-ui);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: center;
  font: normal normal bold $mf_ft_size_title Segoe UI;
  letter-spacing: 0px;
  color: $blue_color;
  opacity: 1;
  margin: auto;
}
</style>